import Gauge from 'components/Gauge/Gauge'
import { FC, ReactElement, useEffect, useRef } from 'react'
import styled from 'styled-components'

const GaugeWithTitle: FC<{
  Icon?: any
  backgroundColor?: string
  category: 'gas' | 'electricity'
  value?: number
  lang?: 'de' | 'fr'
  customTitle?: string | null
  lead: string
  customLead?: string | null
}> = ({
  Icon,
  backgroundColor,
  category,
  value,
  lang = 'de',
  customTitle,
  lead,
  customLead
}): ReactElement => {
  const titles = {
    gas: { de: 'Erdgas', fr: 'Gaz naturel' },
    electricity: { de: 'Strom', fr: 'Électricité' },
  }

  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Title>
        <Icon />
        {customTitle ? customTitle : titles[category][lang]}
      </Title>
      <GaugeContainer>
        <Gauge value={value} />
        <Labels>
          {/* <div>normal</div>
          <div>ungenügend</div> */}
        </Labels>
      </GaugeContainer>
      <SubTitle>
        {' '}
        {customLead ? customLead : lead}
      </SubTitle>
    </Wrapper>
  )
}
const Title = styled.h3`
  font-family: var(--font-plex);
  font-weight: 700;
  margin: 0;
  line-height: 3rem;
  overflow-wrap: break-word;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  svg {
    @media (max-width: 776px) {
      max-height: 2rem;
    }
  }
`
const Percentage = styled.div`
  font-family: var(--font-plex);
  font-weight: 700;
  font-size: 1.5em;
`
const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 1em;
  @media (max-width: 500px) {
    font-size: 0.75em;
    line-height: 0.5em;
  }
`
const GaugeContainer = styled.div`
  display: grid;
  gap: 0.5em;
`
const SubTitle = styled.div`
  /* margin-top: 0.75em; */
  font-weight: 400;
  width: 100%;
  overflow-wrap: break-word;
  text-align: center;
  font-size: 1em;
  @media (max-width: 776px) {
    font-size: 0.75em;
  }
  line-height: 1.5em;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.5em;
  max-width: 80%;
`
const Wrapper = styled.div<{ backgroundColor?: string }>`
  display: flex;
  flex-direction: column;

  gap: 0.5em;
  justify-content: center;
  align-items: center;
  ${({ backgroundColor }) => {
    return backgroundColor ? '--site-background:' + backgroundColor + ';' : ''
  }}
  border-radius: 0.3em;
  // smooth shadow
  box-shadow: 0 2em 2em rgba(0, 0, 0, 0.03);
  background-color: var(--site-background);
  font-family: var(--font-plex);
  padding: 1em 2em;
  @media (max-width: 776px) {
    padding: 1em 1em;
  }
  /* margin: 0 1em; */
  /* max-width: 300px;

@media (max-width: 380px) {
  max-width: 105px;
  } */
`
const LoadingAnimation = styled.div`
  position: relative;
  width: 10px;
  height: 10px;
  margin: 5px;
  border-radius: 5px;
  background-color: currentColor;
  animation: dotFlashing 1s infinite ease alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: currentColor;
    /* color: #9880ff; */
    animation: dotFlashing 1s infinite ease alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: currentColor;
    /* color: #9880ff; */
    animation: dotFlashing 1s infinite ease alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0.4;
      transform: scale(0.9);
    }
  }
`

export default GaugeWithTitle
